import { render, staticRenderFns } from "./ResolveAddressList.vue?vue&type=template&id=b4e92262&scoped=true"
import script from "./ResolveAddressList.vue?vue&type=script&lang=js"
export * from "./ResolveAddressList.vue?vue&type=script&lang=js"
import style0 from "./ResolveAddressList.vue?vue&type=style&index=0&id=b4e92262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e92262",
  null
  
)

export default component.exports